(() => {
  if (window.rafinedPackagePurchaseReady) return;
  window.rafinedPackagePurchaseReady = true;

  function marker(item) {
    const value = item?.properties?.__kaching_bundles;
    if (typeof value !== 'string') return null;
    try { return JSON.parse(value); } catch (_) {
      try { return JSON.parse(atob(value)); } catch (_) { return null; }
    }
  }

  function validPackageItems(items, expected, barId, penProductId) {
    if (!Array.isArray(items) || items.length !== 4 || expected.length !== 4 || new Set(expected).size !== 4 || !barId) return false;
    const ids = items.map(item => Number(item.id));
    if (new Set(ids).size !== 4 || !expected.every(id => ids.includes(id))) return false;
    let group = null;
    return items.every(item => {
      if (Number(item.quantity) !== 1 || item.selling_plan || item.sellingPlanId) return false;
      if (item.parent_id && (Number(item.id) === expected[0] || Number(item.parent_id) !== expected[0])) return false;
      const data = marker(item);
      if (!data || data.bar !== barId || !data.id || !data.deal || !data.v || data.gift) return false;
      if (!group) group = data;
      if (data.id !== group.id || data.deal !== group.deal || data.v !== group.v) return false;
      return Number(item.id) !== expected[0] || (data.main === true && Number(data.pp) === penProductId);
    });
  }

  const controllers = new WeakMap();
  const attach = purchase => {
    if (controllers.has(purchase)) return;
    const form = purchase.querySelector('form.rf-kit-form');
    const mount = purchase.querySelector('[data-package-mount]');
    const add = purchase.querySelector('[data-kit-add]');
    const input = form?.querySelector('[data-package-id]');
    const status = purchase.querySelector('[data-package-status]');
    const reload = purchase.querySelector('[data-package-reload]');
    if (!form || !mount || !add || !input) return;
    const accessoryIds = purchase.dataset.packageAccessoryVariants.split(',').map(Number);
    const penProductId = Number(purchase.dataset.packagePenProduct);
    let queued = false, blocked = true, active = true;
    let timer = null;
    const shade = () => purchase.querySelector('[data-kit-shade]:checked');
    const native = () => mount.querySelector('kaching-bundles-block');
    const packageCard = block => [...block.querySelectorAll('[data-deal-bar-id]')].find(card =>
      card.querySelector('.kaching-bundles__bar-title')?.textContent.toUpperCase().replace(/[^A-Z0-9]/g, '') === 'RAFINEDPACKAGE');
    const current = () => {
      const control = shade(), block = native();
      if (!control || control.disabled || !block || typeof block.items !== 'function' || typeof block.pricing !== 'function') return null;
      const card = packageCard(block), barId = card?.getAttribute('data-deal-bar-id');
      if (!barId || block.selectedDealBarId !== barId) return null;
      const expected = [Number(control.dataset.packageVariantId), ...accessoryIds];
      try {
        const items = block.items();
        if (!validPackageItems(items, expected, barId, penProductId)) return null;
        const price = block.pricing().discountedPrice;
        if (!Number.isFinite(Number(price?.amount)) || Number(price.amount) <= 0 || !price.formatted) return null;
        return { block, price, control };
      } catch (_) { return null; }
    };
    const paint = result => {
      const ready = !!result;
      purchase.dataset.packageReady = String(ready);
      input.disabled = !ready;
      if (!ready) { add.disabled = true; blocked = true; }
      else if (blocked) { add.disabled = false; blocked = false; }
      if (ready) {
        input.value = result.control.dataset.packageVariantId;
        const amount = purchase.querySelector('[data-kit-price]');
        if (amount.textContent !== result.price.formatted) amount.textContent = result.price.formatted;
        if (add.textContent !== purchase.dataset.packageAddLabel) add.textContent = purchase.dataset.packageAddLabel;
        if (status) status.hidden = true;
        if (reload) reload.hidden = true;
      }
    };
    const synchronize = () => {
      if (!active || !purchase.isConnected) return;
      const block = native(), control = shade();
      if (block && control && !control.disabled && typeof block.items === 'function') {
        const card = packageCard(block), barId = card?.getAttribute('data-deal-bar-id');
        if (barId && block.selectedDealBarId !== barId) block.selectedDealBarId = barId;
        if (block.sellingPlanId) block.sellingPlanId = undefined;
        const id = Number(control.dataset.packageVariantId);
        if (Number(block.currentVariantId) !== id) {
          block.currentVariantSource = 'native';
          block.currentVariantId = id;
        }
      }
      paint(current());
    };
    const queue = () => {
      if (queued || !active) return;
      queued = true;
      requestAnimationFrame(() => { queued = false; synchronize(); });
    };
    const observer = new MutationObserver(queue);
    observer.observe(mount, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['class', 'current-variant-id', 'selected-deal-bar-id', 'selling-plan-id'] });
    purchase.addEventListener('change', event => {
      if (!event.target.matches('[data-kit-shade]')) return;
      paint(null);
      queue();
    });
    mount.addEventListener('items-changed', queue);
    mount.addEventListener('kaching-bundles-block-loaded', queue);
    if (reload) reload.addEventListener('click', () => window.location.reload());
    const poll = () => {
      if (!active || !purchase.isConnected) return;
      synchronize();
      timer = window.setTimeout(poll, current() ? 1000 : 250);
    };
    timer = window.setTimeout(poll, 0);
    const timeout = window.setTimeout(() => {
      if (!active || current()) return;
      if (status) status.hidden = false;
      if (reload) reload.hidden = false;
    }, 6000);
    const guard = rotate => {
      const result = current();
      if (!result) { paint(null); queue(); return false; }
      if (rotate && typeof result.block.rotateBundleNonce === 'function') result.block.rotateBundleNonce();
      const refreshed = current();
      if (!refreshed) { paint(null); queue(); return false; }
      return true;
    };
    controllers.set(purchase, { guard, destroy() {
      active = false;
      clearTimeout(timer);
      clearTimeout(timeout);
      observer.disconnect();
      controllers.delete(purchase);
    } });
    synchronize();
  };
  const initialize = root => root.querySelectorAll('[data-package-purchase]').forEach(attach);
  const preventWrongPackage = (event, rotate) => {
    const form = event.type === 'submit' ? event.target : event.target.closest('[data-kit-add]')?.form;
    const purchase = form?.closest('[data-package-purchase]');
    if (!purchase) return;
    const controller = controllers.get(purchase);
    if (!controller || !controller.guard(rotate)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  };
  window.addEventListener('click', event => preventWrongPackage(event, false), true);
  window.addEventListener('submit', event => preventWrongPackage(event, true), true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
  else initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-package-purchase]').forEach(purchase => controllers.get(purchase)?.destroy()));
})();
